module.exports = __webpack_public_path__ + "static/media/icon-x.be145b6d.svg";